import {history} from 'new-components/router/history';
import {delay, put, takeEvery} from 'redux-saga/effects';
import {MOBILE_PAY_SUBMIT, SUBMIT_ADYEN_CARD_ADDITIONAL_DETAILS, SWISH_PAY_SUBMIT_ADDITIONAL_DETAILS} from "../constants/payment.constants";
import {
	getOrder,
	initAdyenPayment,
	checkPaymentStatus,
	checkAdyenPayment,
	checkSwishAdyenPayment,
	checkPaymentStatusAnonymously
} from "../actions/api.actions";
import {getOrderRoute} from "../helpers/routes.helper";
import {START} from "../constants/app-state.constants";
import {CHECK_ADYEN_PAYMENT_SUCCESS, CHECK_PAYMENT_STATUS_SUCCESS, ORDER_SUCCESS} from "../constants/api.constants";
import {PaymentStatuses, PaymentTypes} from "../constants/common.constants";

function* requestRedirectToMobilePay(action) {
	yield put(initAdyenPayment());
}

function* fetchAdyenOrder(action) {
	yield put(getOrder(action.payload.orderId, undefined, true));
}

function* openAdyenOrder(action) {
	history.push(
		getOrderRoute(action.payload.data.order.orderId, true)
	);
}

function* openAdyenCardOrder(action) {
	if (action.payload.returnFromAdyen) {
		history.push(
			getOrderRoute(action.payload.orderId, true)
		);
		return;
	}
	history.replace(
		getOrderRoute(action.payload.orderId, true)
	);
}

function* sendAdyenCheckPaymentStatus(action) {
	//TODO call checkPaymentStatus only after server config is downloaded in restaurant mode
	yield delay(1000);//DEBUG
	yield put(checkPaymentStatus(action.returnFromAdyen.orderId));
}

function* sendAdyenCheckPaymentStatusAnonymously(action) {
	//TODO call checkPaymentStatus only after server config is downloaded in restaurant mode
	yield delay(1000);//DEBUG
	yield put(checkPaymentStatusAnonymously(action.returnFromAdyen.orderId));
}

function* sendAdyenCardCheckPaymentStatus(action) {
	yield delay(2000);//DEBUG
	yield put(checkAdyenPayment(action.data, action.returnFromAdyen));
}

function* sendSwishPaymentCheckPaymentStatus(action) {
	yield put(checkSwishAdyenPayment(action.data));
}

function* cleanUrlFromAdyenParams(action) {
	history.replace({}, '', window.location.pathname);
}

export const paymentSaga = function* paymentSaga() {
	yield takeEvery(
		[
			MOBILE_PAY_SUBMIT
		],
		requestRedirectToMobilePay
	);
	
	yield takeEvery(
		[
			SUBMIT_ADYEN_CARD_ADDITIONAL_DETAILS
		],
		sendAdyenCardCheckPaymentStatus
	);
	
	yield takeEvery(
		[
			SWISH_PAY_SUBMIT_ADDITIONAL_DETAILS
		],
		sendSwishPaymentCheckPaymentStatus
	);
	
	yield takeEvery(
		action => action.type === CHECK_PAYMENT_STATUS_SUCCESS && action.payload.isAdyenOrder && action.payload.data.status === PaymentStatuses.complete,
		fetchAdyenOrder
	);
	
	yield takeEvery(
		action => action.type === CHECK_ADYEN_PAYMENT_SUCCESS && action.payload.data.resultCode === PaymentStatuses.authorised
			&& !action.payload.data.isFromProfile,
		openAdyenCardOrder
	);
	
	yield takeEvery(
		action => action.type === ORDER_SUCCESS && action.payload?.isAdyenOrder,
		openAdyenOrder
	)
	
	yield takeEvery(
		action => action.type === START && action.returnFromAdyen && action.returnFromAdyen.paymentType === PaymentTypes.payWithMobilePay && action.isCustomerLoggedIn,
		sendAdyenCheckPaymentStatus);
	
	yield takeEvery(
		action => action.type === START && action.returnFromAdyen && action.returnFromAdyen.paymentType === PaymentTypes.payWithMobilePay && !action.isCustomerLoggedIn,
		sendAdyenCheckPaymentStatusAnonymously);
	
	yield takeEvery(
		action => action.type === START && action.returnFromAdyen && action.returnFromAdyen.paymentType === PaymentTypes.payWithAdyenCard,
		sendAdyenCardCheckPaymentStatus);
	

	
	yield takeEvery(action => action.type === START && action.returnFromAdyen, cleanUrlFromAdyenParams);
};
